define('paychex.app.messages/services/MessageListDataService',[
    'lodash',
    'paychex.core/Errors',
    'paychex.core/Logger',
    'paychex.core/Repository',
    'paychex.core/TriggerMixin',
    'paychex.app.messages/data/RemoteGetPNGSSOMessages',//'getMessagesEndpoint',
    'paychex.app.messages/data/RemoteDeleteMessages',//'deleteMessagesEndpoint',
    'paychex.app.messages/data/RemoteMarkMessagesReadRequest', //'markMessagesReadEndpoint',
    'paychex.app.messages/data/RemoteMarkMessagesUnreadRequest',// 'markMessagesUnreadEndpoint',
    'paychex.app.messages/messages/MessageStatus175'
], function (_,
             Errors,
             Logger,
             Repository,
             TriggerMixin,
             getPNGSSOMessagesRequest,
             deleteMessagesRequest,
             markMessagesReadRequest,
             markMessagesUnreadRequest,
             MessageStatus175) {

    'use strict';

    /**
     * @class paychex.app.landing.shared.messageList.GetMessagesService
     * @param {function} dataOperationFactory - The base factory for making data calls in our Angular framework
     * @param {external:paychex.app.common.services.INotificationService} INotificationService - Notification Service
     *@param {object} CacheFactory - Factory that constructs objects and gives access to them.
     */
    return [
        'dataOperationFactory',
        'INotificationService',
        'CacheFactory',
        function (dataOperationFactory,
                  INotificationService,
                  CacheFactory) {

            var self = this,
                isLoaded = false, // start false so UI is disabled until first real load completes (used in Object.defineProperty)

                // track how often each client/mode combination was requested;
                // this determines when we should use the cache vs. call the remote
                callCounts = {},

                FIFTEEN_DAYS = 1.296e9, // messages expire after 15 days

                // create our various data calls
                getPngSSOMessages = dataOperationFactory(getPNGSSOMessagesRequest),
                deleteMessagesRemote = dataOperationFactory(deleteMessagesRequest),
                markMessagesReadRemote = dataOperationFactory(markMessagesReadRequest),
                markMessagesUnreadRemote = dataOperationFactory(markMessagesUnreadRequest),

                log = Logger.get('paychex.app.landing.shared.messageList.MessageListDataService'),
                cache = CacheFactory.fromStore(Repository.local, {expiresAfter: FIFTEEN_DAYS}),

                isMessagesKey = _.partial(_.isEqual, 'messages');

            /**
             * Converts mode and clients value to string
             * @param {string} mode - The mode to retrieve messsages for
             * @param {string | array} clients - client or clientId
             * @returns {string} Mode and Clients
             */
            function key(mode, clients) {
                return _.toString([_.toString(mode), _.toString(clients)]);
            }

            // this method deep searches through the remote data to find any and
            // all paths to a 'messages' collection; this is a bit more future-proof
            // than relying on specific hard-coded paths, protecting us from multi-
            // client, batch retrievals, etc. -- and since this will only run from
            // the mark-read/unread/delete *success* callbacks, i'm pretty sure we won't
            // accidentally return paths to remote error/validation 'messages'
            /**
             * Deep searches through the remote data to find any and all paths to a 'messages' collection
             * @param {object} data - The message data
             * @param {string} path - The location path of message data
             * @param {array} paths - Previously found paths to messages collections plus any messages collections at the current path
             * @returns {Array} Paths to message(s)
             */
            function getPathsToMessages(data, path, paths) {

                var obj = !!path ? _.get(data, path) : data,
                    keys = _.keys(obj),

                    // some messages come back `null` -- we don't want those
                    isValueAnArray = _.flow(_.partial(_.result, obj), _.isArray),
                    isValidMessagesKey = _.overEvery([isMessagesKey, isValueAnArray]);

                if (!_.isObject(obj)) {
                    return []; // leaf node; ignore
                }
                return _(paths)
                    .union(
                        // previously found paths to messages collections
                        // plus any messages collections at the current path
                        _.map(_.filter(keys, isValidMessagesKey), function findPathsAndMessages() { // eslint-disable-line lodash/prefer-times
                            return (!!path ? path + '.' : '') + key;
                        }),
                        // recurse over the remaining values, checking for messages collections
                        _.map(_.reject(keys, (isValidMessagesKey)), function findRemainingMessages() { // eslint-disable-line lodash/prefer-times
                            return getPathsToMessages(data, (!!path ? path + '.' : '') + key, paths);
                        }))
                    .flatten()
                    .compact()
                    .value();

            }

            // these next few high-order functions are used to update the cache when
            // remote calls return successfully -- i pass in the state at the time the
            // remote call was invoked and then create and return an appropriate promise
            // success handler. this ensures the data used during the promise success
            // handler is the same data used when invoking the remote call; otherwise, if
            // the user changed clients after a remote call was invoked but BEFORE it
            // resolved, we would end up modifying the wrong client's cached messages
            /**
             * Updates the cache when remote calls return successfully
             * @param {*} cacheKey - used to update cache
             * @param {*} hashKeys - used to update readStatus
             * @param {string} status - message status
             * @returns {updateCachedMessages} - cache updated with correct messages
             */
            function updateMessagesInCache(cacheKey, hashKeys, status) {
                // the promise handler that receives the cached messages that need updating
                return function updateCachedMessages(data) {
                    _.forEach(getPathsToMessages(data, '', []), function updateMessagesAtPath(path) {
                        // loop through each messages collection, changing the
                        // readStatus of any messages with a matching hash key
                        var updatedMessages = _.map(_.get(data, path), function updateMessageStatus(message) {
                            if (_.includes(hashKeys, message.hashMessageKey)) {
                                message.readStatus = status;
                            }
                            return message;
                        });
                        // overwrite the existing messages with the modified messages
                        _.set(data, path, updatedMessages);
                    });
                    // now update the cache -- this will notify any subscribed observers
                    return cache.set(cacheKey, data);
                };
            }

            /**
             * Removes and overwrites messaged with modified versions and updates cache.
             * @param {*} cacheKey - used to update cache
             * @param {*} hashKeys - used to update readStatus
             * @returns {updateCachedMessages} - cache updated with correct messages
             */
            function removeMessagesFromCache(cacheKey, hashKeys) {
                // the promise handler that receives the cached messages:
                return function updateCachedMessages(data) {
                    _.forEach(getPathsToMessages(data, '', []), function removeDeletedMessagesAtPath(path) {
                        // loop through each messages collection, removing any messages that were deleted
                        var updatedMessages = _.filter(_.get(data, path), function wasNotDeleted(message) {
                            return !(_.includes(hashKeys, message.hashMessageKey));
                        });
                        // overwrite the existing messages with the modified messages
                        _.set(data, path, updatedMessages);
                    });
                    // now update the cache -- this will notify any subscribed observers
                    return cache.set(cacheKey, data);
                };
            }

            /**
             * Generates the callback to invoke when the mark read/unread remote calls succeeds
             * @param {*} hashKeys - used to update readStatus
             * @param {string} status - message status
             * @returns {updateHandler} - updated handler
             */
            function updateMessageStatuses(hashKeys, status) {
                return function updateHandler() {
                    // because of general (all client) messages, go through all cached messages
                    // (regardless of the currently selected client and mode). since cache.set
                    // returns a promise, we can convert each cache key into a promise that is
                    // only resolved once those cached messages have been updated
                    return _.map(cache.keys(), function getCacheUpdatePromise(cacheKey) {
                        return cache.get(cacheKey, true)
                            .then(updateMessagesInCache(cacheKey, hashKeys, status));
                    });
                };
            }

            /**
             * Generates the callback to invoke when the delete remote call succeeds
             * @param {*} hashKeys - used to update readStatus
             * @returns {deleteSuccessHandler} - removes deleted messages from cache
             */
            function removeDeletedMessagesFromCache(hashKeys) {
                return function deleteSuccessHandler() {
                    // because of general (all client) messages, go through all cached messages
                    // (regardless of the currently selected client and mode). since cache.set
                    // returns a promise, we can convert each cache key into a promise that is
                    // only resolved once those cached messages have been updated
                    return _.map(cache.keys(), function getCacheUpdatePromise(cacheKey) {
                        return cache.get(cacheKey, true)
                            .then(removeMessagesFromCache(cacheKey, hashKeys));
                    });
                };
            }
            /**
             * Generates the callback to invoke when the delete remote call fails
             * @param {number} messageCount - total count of messages
             * @returns {deleteFailureHandler} - handles the failed message delete
             */
            function deleteFailed(messageCount) {
                return function deleteFailureHandler(reason) {
                    var messageText = 'selected message' + (messageCount !== 1 ? 's' : ''); // TODO: localize?
                    log.error('deleteMessages failed', reason);
                    INotificationService.displaySingleMessage({message: new MessageStatus175(messageText)})
                        .then(function handleDialogResult(buttonResult) {
                            if (buttonResult.value === MessageStatus175.OK) {
                                log.debug('User has been informed of message delete failure');
                            }
                            return buttonResult;
                        })
                        .catch()
                        .done();
                    Errors.throw(reason); // propagate failure
                };
            }

            /**
             * Invokes a method and updates the status
             * @param {function} method - the method to be invoked
             * @param {List} messageList - list of messages marked read
             * @param {string} status - status of the message list
             * @return {promise} the method being invoked with hashKeys and specified status as arguments
             */
            function invokeMethodAndUpdateStatus(method, messageList, status) {
                var hashKeys = _.map(messageList, 'hashMessageKey');
                return method(null, messageList)
                    .then(updateMessageStatuses(hashKeys, status));
            }

            TriggerMixin.call(this);

            Object.defineProperty(self, 'isLoaded', {
                get: function get() {
                    return isLoaded;
                },
                set: function set(value) {
                    if (!_.isEqual(value, isLoaded)) {
                        isLoaded = value;
                        self.trigger('is-loaded-changed', isLoaded);
                    }
                }
            });
            /**
             * Loads trigger
             */
            function triggerIsLoaded() {
                self.isLoaded = true;
            }

            /**
             * @function paychex.app.landing.shared.messageList.MessageBoardRemoteService#loadMessages
             * @returns {Promise} A promise that will be resolved with the remote messages list.
             * @param {String} [mode] An optional mode to retrieve messages for.
             * @param {String|Array} [clientIds] An optional array or comma-separated string of client IDs to retrieve messages for.
             */
            self.loadMessages = function loadMessages(mode, clientIds) {
                var data = _.merge({
                    eligible: true,
                    mode: _.toString(mode) || undefined,
                    clientIds: _.toArray(clientIds) || undefined
                });
                self.isLoaded = false;
                return cache.set(key(mode, clientIds), _.partial(getPngSSOMessages, null, data))
                    .finally(triggerIsLoaded);
            };

            /**
             * @function paychex.app.landing.shared.messageList.MessageBoardRemoteService#observeMessages
             * @returns {Observable} A stream that receives notifications whenever the cached value for the specified mode and client(s) changes.
             * @param {String} [mode] The mode to retrieve messages for.
             * @param {String|Array} [clientIds] An array or comma-separated string of client IDs to retrieve messages for.
             */
            self.observeMessages = function observe(mode, clientIds) {
                return cache.observe(key(mode, clientIds));
            };

            /**
             * @function paychex.app.landing.shared.messageList.MessageBoardRemoteService#getMessages
             * @returns {Promise} A promise that will be resolved with the remote messages list.
             * @param {String} [mode] An optional mode to retrieve messages for.
             * @param {String|Array} [clientIds] An optional array or comma-separated string of client IDs to retrieve messages for.
             * @param {Boolean} [forceLoad=false] An optional boolean to indicate if the real remote call should be invoked to load
             *  messages; otherwise, the cached value will be retrieved. If false, and if no real call has fired off
             */
            self.getMessages = function getMessages(mode, clientIds, forceLoad) {
                var promise,
                    cacheKey = key(mode, clientIds);
                self.isLoaded = false;
                if (!!forceLoad) {
                    // make the real data call and wait for it to complete
                    promise = self.loadMessages(mode, clientIds);
                } else {
                    if (!_.has(callCounts, cacheKey)) {
                        // fire off the real data call, but don't wait for
                        // it to complete; instead, we'll return the cached
                        // value (if one exists). later, if MessageListModelService
                        // cares about the real messages, it will update its
                        // internal model when the real values are returned
                        self.loadMessages(mode, clientIds);
                    }
                    // return the cached value (if none exists, wait for one to be set)
                    promise = cache.get(cacheKey, /* prime from local store */ true);
                    if (_.has(callCounts, cacheKey)) {
                        promise = promise.finally(triggerIsLoaded);
                    }
                }
                callCounts[cacheKey] = (callCounts[cacheKey] || 0) + 1;
                return promise; // return the result of the remote call or the cached value
            };

            /**
             * @function paychex.app.landing.shared.messageList.MessageBoardRemoteService#deleteMessages
             * @param {List} messages - List of Messages to be deleted.
             * @returns {Promise} An Angular promise that will be resolved with the remote messages list.
             */
            self.deleteMessages = function deleteMessages(messages) {
                var hashKeys = _.map(messages, 'hashMessageKey');
                return deleteMessagesRemote(null, messages)
                    .then(
                        removeDeletedMessagesFromCache(hashKeys),
                        deleteFailed(messages.length)
                    );
            };

            /**
             * Adding support for Multiple Messages Read.  Returns an Angular promise that will be resolved with the remote messages list.
             * @function paychex.app.landing.shared.messageList.MessageBoardRemoteService#markMessagesRead
             * @param {List} messageList - list of messages marked read
             */
            self.markMessagesRead = function markRead(messageList) {
                // TODO: as part of larger refactor, move all constants into publicly accessible object
                invokeMethodAndUpdateStatus(markMessagesReadRemote, messageList, 'READ');
            };

            /**
             * Adding support for Multiple Messages UnRead
             * @function paychex.app.landing.shared.messageList.MessageBoardRemoteService#markMessagesRead
             * @param messageList (List) list of messages marked unread
             * @returns {Promise} an Angular promise that will be resolved with the remote messages list.
             */

            self.markMessagesUnread = function markUnread(messageList) {
                // TODO: as part of larger refactor, move all constants into publicly accessible object
                invokeMethodAndUpdateStatus(markMessagesUnreadRemote, messageList, 'UNREAD');
            };

        }
    ];

});

